<template>
  <div class="modal_mask">
    <div class="wrapper_modal">
      <div class="content">
        <h1 class="title_buy_pix">{{ $t("msg.modalBuyBluePix.buy_blue") }}</h1>
        <svg
          class="x_icon"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="2"
          @click="toggleModalBuyBluePIX()"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>

        <div class="connecting" v-if="step == 1">
          <p>{{ $t("msg.modalBuyBluePix.connecting_swapix") }}</p>

          <div class="connecting_content">
            <img src="../../assets/images/blue_icon.svg" alt="blue icon" />

            <div class="b">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>

            <img src="../../assets/images/swapix.png" alt="swapix" />
          </div>

          <div class="connecting_warning">
            <span>{{ $t("msg.modalBuyBluePix.only_accepts") }}</span>

            <span>{{ $t("msg.modalBuyBluePix.pix_purcase_processed") }}</span>
          </div>

          <div
            class="mw100 combo_0"
            style="
              display: flex;
              align-items: center;
              padding: 10px;
              margin-top: 10px;
            "
          >
            <input
              type="checkbox"
              id="confirTerms"
              value="confirTerms"
              v-model="confirTerms"
              style="
                width: 15px;
                height: 15px;
                margin-right: 5px;
                color: #342365;
              "
            />

            <label for="confirTerms" style="cursor: pointer">
              <p
                class="tal_c fs_00r"
                style="display: flex; font-size: 12px !important"
                v-html="$t('msg.modalBuyBluePix.swapix_terms')"
              ></p>
            </label>
          </div>

          <div style="margin-top: 10px" v-if="confirTerms">
            <div
              style="
                background: #342365;
                padding: 5px 15px 5px 15px;
                border-radius: 10px;
                cursor: pointer;
              "
              @click="next()"
            >
              {{ $t("msg.modalBuyBluePix.btn_next") }}
            </div>
          </div>

          <div style="margin-top: 10px" v-if="!confirTerms">
            <div
              style="
                background: grey;
                padding: 5px 15px 5px 15px;
                border-radius: 10px;
                cursor: not-allowed;
              "
            >
              {{ $t("msg.modalBuyBluePix.btn_next") }}
            </div>
          </div>
        </div>

        <div class="swapix" v-if="step == 2 || step == 3">
          <div class="swapix_b" v-if="step == 2">
            <div class="welcome_swapix">
              <p>{{ $t("msg.modalBuyBluePix.welcome") }}</p>
              <img src="../../assets/images/swapix.png" alt="swapix" />
            </div>

            <div class="content_swapix" style="padding-bottom: 1rem">
              <p>{{ $t("msg.modalBuyBluePix.payment_being_processed") }}</p>
              <p>{{ $t("msg.modalBuyBluePix.wait") }}</p>
            </div>

            <div style="padding: 1rem 0">
              <div class="loadingspinner" />
            </div>

            <div class="payment_being_processed">
              <div style="width: 3.5rem">
                <span style="color: black; font-size: 3.2rem">R$</span>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="swapix_b_arrow"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="{2}"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
              <img
                class="processed_coin"
                src="../../assets/images/coins/coin_USDT.png"
                alt="USDT icon"
                title="USDT"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="swapix_b_arrow"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="{2}"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
              <img
                class="processed_coin"
                src="../../assets/images/blue_icon.svg"
                alt="BLUE icon"
                title="BLUE"
              />
            </div>
          </div>

          <div class="swapix_a" v-if="step == 3">
            <div class="content_swapix">
              <p>
                {{ $t("msg.modalBuyBluePix.payment") }}:
                {{ amountToSend.toFixed(2) }} USDT
              </p>
              <p>
                {{ $t("msg.modalBuyBluePix.convert_price") }}:
                {{ pixData.convertedPrice.toFixed(2) }}
              </p>
              <br />
              <p>
                {{ $t("msg.value") }}: R$ {{ pixData.amountBrl.toFixed(2) }}
              </p>
              <p>
                SWAPiX {{ $tc("msg.fee", 1) }} (R$2 + 2.04%): R$
                {{ pixData.feeBrl.toFixed(2) }}
              </p>
              <span class="total_in_BRL"
                >{{ $t("msg.total_to_pay") }}: R$
                {{ pixData.totalBrl.toFixed(2) }}</span
              >
            </div>

            <qrcode :value="pixData.emv" :options="{ width: 200 }"></qrcode>

            <!-- <span class="pix_ID">Unique ID: {{ pixData.operationId }}</span> -->

            <p class="p">
              <button
                class="
                  main_blue_lt_bg main_blue_lt_bg_hover
                  component_main_button
                  upper
                "
                type="button"
                v-clipboard:copy="pixData.emv"
                v-clipboard:success="onCopySuccess"
                v-clipboard:error="onCopyError"
              >
                {{ $tc("msg.copy", 1) }}
              </button>
            </p>

            <div style="padding: 1rem 0">
              <div class="loadingspinner" />
            </div>

            <p class="waiting_deposit">
              {{ $t("msg.waiting_deposit") }} <br />
              {{ $t("msg.expire_in") }}
              {{ formatDate(dateEnd) }} <br />
            </p>

            <p style="padding: 0.5rem 0; color: #342365">
              {{ $t("msg.average_time") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import spacetime from "spacetime";

export default {
  props: ["blueAmount", "usdtAmount"],
  created() {
    // setTimeout(() => {
    //   this.step = 3;
    // }, 4000);
  },
  data: () => ({
    dateEnd: "",
    timmer: 10,
    connecting: false,
    step: 1,
    purchases: [],
    pixData: "",
    confirTerms: false,
    swapix: {
      a: false,
      b: false,
      c: false,
    },
    trade: "",

    testeeeee: {
      emv: "00020101021226910014br.gov.bcb.pix2569api.developer.btgpactual.com/v1/p/v2/b0e0085d8465475d862accd023f727515204000053039865802BR5924Smartpay Pagamentos Ltda6013FLORIANOPOLIS61088805897162070503***630493B8",
      address: "kk6g232xel65a0daee4dd13kk1072266777",
      operation: {
        operation_type: "sell",
        curout: "txusdt",
        curbase: "brl",
        curconv: "txusdt",
        nfe: "in",
        txIn: { message: "TPiXaBPVTJ1M3d8YFrm2YFJEF4hFXpCGVw" },
        operation_id: "1654873710420",
        rate: {
          amount_brl: "499.75",
          price_usd: "4.9970",
          total_brl: "516.74",
          fee_brl: "16.99",
          send_usd: "100.00",
          timeout: 772,
          amount_usd: "100.00",
          price_txusdt: 1,
          value_txusdt: "100.000000",
          send_txusdt: "100.000000",
        },
        remove: "true",
      },
    },

    amountToSend: "",
    addressToSEnd: "",
  }),
  methods: {
    toggleModalBuyBluePIX() {
      this.$emit("toggleModalBuyBluePIX");
    },

    getHours(teste) {
      var n = teste;
      var num = n;
      var hours = num / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);

      if (teste > 60) {
        return rhours > 1
          ? rhours + " Hs " + rminutes + " Min"
          : rhours + " H " + rminutes + " Min";
      } else {
        return teste + " Min";
      }
    },

    next() {
      this.step = this.step + 1;

      if (this.step == 2) {
        this.postTrade();
      }
    },

    async postTrade() {
      let value = this.blueAmount;
      let form = {
        sourceCurrency: "USDT",
        targetAmount: parseFloat(value),
      };

      await this.$store
        .dispatch("postTrade", form)
        .then((r) => {
          console.log(r);
          if (r.status == 200) {
            this.amountToSend = r.data.estimatedAmount;
            this.getPurchases();
          }
        })
        .catch((e) => {
          Swal.fire({
            icon: "error",
            title: this.$t("msg.error"),
            text: this.$t("msg.error_xgateway"),
          });
          this.toggleModalBuyBluePIX();
          this.step = 1;
        });
    },

    async getPurchases() {
      try {
        let resp = await this.$store.dispatch("getPurchases");
        this.purchases = resp.data;
      } catch (e) {
        this.logError(e);
      }
    },

    formatDate(value) {
      let s = spacetime(value);
      let end = s.add(20, "minutes");
      return end.format("dd/MM/yyyy HH:mm:SS");
    },

    async checkTranscationStatus() {
      let trades = this.purchases;
      for (let i in trades) {
        if (trades[i].status == "waiting") {
          console.log(trades[i]);
          let address = trades[i].targetAddress;
          let tradeId = trades[i].id;

          // let date = new Date(trades[i].createdAt)
          // this.dateEnd = date.setMinutes(10);

          this.dateEnd = trades[i].createdAt;

          let body = {
            tradeId: tradeId,
            address: address,
            amount: parseFloat(this.amountToSend.toFixed(2)),
          };

          let resp = await this.$store.dispatch(
            "postPurchasePixGenerate",
            body
          );

          if (resp.status == 200) {
            this.step = 3;
            this.pixData = resp.data;
          }
        }
      }
      this.loading = false;
    },

    toggleSwapixContent() {},

    checkStep() {
      if (this.step == 3) {
        setInterval(() => {
          this.getTradeTracking();
        }, 10000);
      }
    },

    async getTradeTracking() {
      let resp = await this.$store.dispatch("getTrade");
      this.trade = resp.data;
      this.checkStatus();
    },

    checkStatus() {
      if (this.trade.status) {
        if (this.trade.status == "done") {
          Swal.fire({
            icon: "success",
            title: this.$t("msg.success"),
            text: this.$t("msg.modalBuyBluePix.completed_buy"),
          });

          this.toggleModalBuyBluePIX();
        }
      }
    },
  },
  watch: {
    purchases: function () {
      this.checkTranscationStatus();
    },

    step: function () {
      this.checkStep();
    },
  },
};
</script>


<style lang="scss" scope>
.modal_mask {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 998;
  overflow: auto;
}

.loadingspinner {
  padding: 1rem 0;
  pointer-events: none;
  width: 3rem;
  height: 3rem;
  border: 0.3rem solid transparent;
  border-color: #eee;
  border-top-color: #342365;
  border-radius: 50%;
  animation: loadingspin 1s linear infinite;
}

.wrapper_modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .content {
    position: relative;
    border-bottom-right-radius: 6px;
    border-bottom-left-radius: 6px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    max-width: 485px;
    max-height: 765px;
    width: 100%;
    background-color: #fff;

    .title_buy_pix {
      background: #342365;
      border-top-right-radius: 6px;
      border-top-left-radius: 6px;
      padding: 1rem 1.5rem;
      text-align: start;
      font-size: 1.5rem;
      margin-bottom: 0;
    }

    .x_icon {
      position: absolute;
      top: 1.2rem;
      width: 1.2rem;
      right: 1rem;
      cursor: pointer;

      &:hover {
        opacity: 0.7;
      }
    }

    .connecting {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 1.5rem 0;
      width: 100%;
      max-width: 400px;
      margin: auto;

      p {
        color: #342365;
        font-size: 1.4rem;
        font-weight: 600;
        margin-bottom: 0;
      }

      .connecting_content {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 100%;
        margin-top: 1rem;

        img {
          width: 3rem;
        }

        img:last-child {
          width: 6rem;
        }

        .b {
          display: inline-block;
          position: relative;
          width: 80px;
          height: 80px;
        }

        .b div {
          position: absolute;
          top: 33px;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #342365;
          animation-timing-function: cubic-bezier(0, 1, 1, 0);
        }

        .b div:nth-child(1) {
          left: 8px;
          animation: b1 0.6s infinite;
        }
        .b div:nth-child(2) {
          left: 8px;
          animation: b2 0.6s infinite;
        }
        .b div:nth-child(3) {
          left: 32px;
          animation: b2 0.6s infinite;
        }
        .b div:nth-child(4) {
          left: 56px;
          animation: b3 0.6s infinite;
        }
        @keyframes b1 {
          0% {
            transform: scale(0);
          }
          100% {
            transform: scale(1);
          }
        }
        @keyframes b3 {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(0);
          }
        }
        @keyframes b2 {
          0% {
            transform: translate(0, 0);
          }
          100% {
            transform: translate(24px, 0);
          }
        }
      }

      .connecting_warning {
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        span {
          margin-top: 1rem;
          color: #000;
        }
      }
    }

    .swapix {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 1rem;
      width: 100%;
      max-width: 400px;
      margin: auto;

      .welcome_swapix {
        display: flex;
        align-items: center;
        justify-content: center;

        p {
          color: #342365;
          font-size: 1.4rem;
          font-weight: 600;
          margin-bottom: 0;
          margin-right: 8px;
        }

        img {
          width: 6rem;
        }
      }

      .content_swapix {
        display: flex;
        justify-content: start;
        flex-direction: column;
      }

      .swapix_a {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 1rem;

        p {
          color: #000;
          margin-bottom: 0;
        }

        span {
          color: #342365;
          margin-top: 1rem;
        }

        .total {
          margin-top: 1rem;
          font-size: 1.1rem;
        }

        .total_in_BRL {
          font-weight: 600;
          margin-top: 0;
          font-size: 1.1rem;
        }

        .qrcode {
          width: 9rem;
          color: #000;
          margin-top: 1rem;
        }

        .pix_ID {
          margin-top: 0rem;
          font-weight: 600;
        }

        .loading {
          color: #000;
          width: 1.5rem;
          margin: 1rem 0;
        }

        .waiting_deposit {
          text-align: center;
          font-size: 1.1rem;
        }
      }

      .swapix_b {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 1rem;

        p {
          color: #000;
          margin-bottom: 0;
        }

        .payment_being_processed {
          display: flex;
          align-items: center;
          justify-content: space-around;
          width: 100%;
          margin: 1rem 0;

          .swapix_b_arrow {
            color: #342365;
            width: 2.5rem;
          }

          .processed_coin {
            width: 3.5rem;
          }
        }

        .loadingspinner {
          padding: 1rem 0;
          pointer-events: none;
          width: 3rem;
          height: 3rem;
          border: 0.3rem solid transparent;
          border-color: #eee;
          border-top-color: #342365;
          border-radius: 50%;
          animation: loadingspin 1s linear infinite;
        }

        @keyframes loadingspin {
          100% {
            transform: rotate(360deg);
          }
        }
      }

      .swapix_c {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        padding: 1rem;

        p {
          color: #000;
          margin-bottom: 0;
        }

        button {
          margin-top: 1.5rem;
          padding: 8px 25px;
          color: #fff;
          background: #342365;
          cursor: pointer;
          border-radius: 4px;
          font-weight: 600;
          font-size: 1rem;
          transition: all ease-in-out 0.2s;

          &:hover {
            background: rgba(52, 35, 101, 0.95);
          }
        }
      }
    }
  }
}

@media only screen and (max-width: 900px) {
  .wrapper_modal {
    .content {
      padding: 2rem 1.5rem;
      max-width: 350px;
      // max-height: 450px;
    }
  }
}

@media only screen and (max-width: 350px) {
  .wrapper_modal {
    .content {
      max-width: 300px;
      // max-height: 450px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalBuyBluePIX.vue